const abbey = "#585A5D";
const black = "#000";
const blackRussian0 = "rgba(4, 15, 40, 0)";
const blackRussian = "rgb(4, 15, 40)";
const white = "#FFF";
const white54 = "rgba(255, 255, 255, .54)";
const white70 = "rgba(255, 255, 255, .7)";
const white80 = "rgba(255, 255, 255, .8)";
const darkBlue = "#000c28";
const darkGray = "#57595C";
const green = "#62CF33";
const ifitBlue = "#0096d6";
const lightGray = "#F4F4F4";
const middleGray = "#B9BABB";
const mountainMeadow = "#28E1A5";
const purple = "#830DB4";
const raven = "#828385";
const red = "#EC3324";
const scienceBlue = "#0069D2";
const shark = "#2E3134";
const shark54 = "rgba(46, 49, 52, 0.54)";
const shark80 = "rgba(46, 49, 52, 0.8)";
const venetian = "#BE0219";

module.exports = {
  abbey,
  black,
  blackRussian0,
  blackRussian,
  white,
  white54,
  white70,
  white80,
  darkBlue,
  darkGray,
  green,
  ifitBlue,
  lightGray,
  middleGray,
  mountainMeadow,
  purple,
  raven,
  red,
  scienceBlue,
  shark,
  shark54,
  shark80,
  venetian
};
